import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../Baseurl";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const cust_id = localStorage.getItem("cust_id");
  const [cartCount, setCartCount] = useState(0);
  const [cartItems, setCartItems] = useState([]);

  const fetchCartDetails = async () => {
    if (!cust_id) return;
    try {
      const response = await axios.get(`${baseurl}CheckCartItems/${cust_id}`);
      setCartItems(response.data.cartItems || []);
      setCartCount(response.data.totalItems || 0);
    } catch (err) {
      console.error("Error fetching cart:", err);
    }
  };

  // Fetch on load and whenever cust_id changes
  useEffect(() => {
    if (cust_id) fetchCartDetails();
  }, [cust_id]);

  return (
    <CartContext.Provider value={{ cartCount, cartItems, fetchCartDetails }}>
      {children}
    </CartContext.Provider>
  );
};
